import React from 'react';
import { BadgeCheckIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
const FEET_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/79987d02-a2c7-410c-aae6-e564c62c2839.jpg';
const CHECKOUT_URL = 'https://camina-para-abajo.impultienda.ar/checkout';
export function PricingCta() {
  return <section id="oferta" className="relative w-full overflow-hidden bg-brand-dark" data-id="element-157" data-mp="jaiqfmn3hsvo">
      <img src={FEET_IMG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-15" data-id="element-158" data-mp="ebnvxnfrmfvq" />
      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:py-28" data-id="element-159" data-mp="aam6tzfkbk7h">
        <Reveal data-id="element-160" data-mp="5c149tcu8ofv">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-semibold text-white" data-id="element-161" data-mp="5ckdmlofa4ia">
            <ClockIcon className="h-4 w-4" data-id="element-162" data-mp="24lr5epbsl6fy" /> Cupos limitados — Precio de lanzamiento
          </span>
          <h2 className="mt-6 font-display text-3xl font-bold leading-tight text-white sm:text-5xl" data-id="element-163" data-mp="1zn61ofxc04mr">
            Empezá tu transformación hoy
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-lg text-white/85" data-id="element-164" data-mp="ouk9hzgbmudi">
            6 módulos de conocimiento puro + 3 bonos de regalo. Todo lo que necesitás para
            transformarte caminando.
          </p>

          <div className="mx-auto mt-8 max-w-sm rounded-2xl bg-white/10 px-6 py-5 ring-1 ring-white/20" data-id="element-165" data-mp="ftcouk6q9s1w">
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-white/65" data-id="element-166" data-mp="13jgpciomdboo">Precio especial</p>
            <p className="mt-1 font-display text-5xl font-bold text-white" data-id="element-167" data-mp="17md6s62fb1r1">22.990$</p>
            <p className="mt-2 flex items-center justify-center gap-2 text-sm font-medium text-white/85" data-id="element-168" data-mp="tsltqnphgzqk">
              <BadgeCheckIcon className="h-5 w-5 text-sky-200" data-id="element-169" data-mp="ypud2rmdb9te" /> Pago con Mercado Pago
            </p>
          </div>

          <div className="mt-8" data-id="element-170" data-mp="1r89enwaqklab">
            <CtaButton href={CHECKOUT_URL} trackingEvent="InitiateCheckout" className="bg-white text-brand-dark shadow-black/20 hover:bg-cream" data-id="element-171" data-mp="1r8hr5n2y5okz">
              QUIERO EL PACK.
            </CtaButton>
          </div>
          <p className="mt-6 flex items-center justify-center gap-2 text-sm font-medium text-white/85" data-id="element-172" data-mp="1r626i26ufngm">
            <ShieldCheckIcon className="h-5 w-5" data-id="element-173" data-mp="1m77q16wcmazo" /> Devolución de 7 días — sin preguntas ni vueltas
          </p>
        </Reveal>
      </div>
    </section>;
}